<template>
    <div class="photo-uploader-wrapper relative block mx-auto">
        <button
            class="photo-uploader relative flex justify-center items-center mx-auto mb-3 text-primary"
            :class="{ 'plus-opacity-0': filePreview }"
        >
            <SvgIcon
                classes="photo-uploader__camera"
                width="76px"
                height="76px"
                icon="camera"
            />
            <span
                class="photo-uploader__plus absolute flex justify-center items-center"
            >
                <SvgIcon
                    classes="svg-plus"
                    width="8px"
                    height="8px"
                    icon="plus"
                />
                <SvgIcon
                    classes="svg-edit"
                    width="12px"
                    height="12px"
                    icon="edit"
                />
            </span>
            <img
                v-if="filePreview && showAvatar"
                class="file-preview"
                :src="filePreview"
                ref="filePreview"
            />
            <template v-else>
                <span
                    v-if="$route.path === '/settings'"
                    class="file-preview flex justify-center items-center flex-col"
                >
                    <UserAvatar />
                </span>
            </template>
        </button>
        <input
            type="file"
            ref="fileUpload"
            @change="addFile"
            class="photo-uploader-input absolute"
        />
        <ul class="formulate-input-errors text-center" v-if="!hasAvatar && showError">
            <li
                role="status"
                aria-live="polite"
                class="formulate-input-error text-center"
            >
                {{ $t("Profile picture required") }}
            </li>
        </ul>
    </div>
</template>

<script>
import UserAvatar from "../Icons/UserAvatar";
import SvgIcon from "../UI/SvgIcon";
export default {
    name: "PhotoUploader",
    props: {
        showError: {
            type: Boolean,
            default: true
        },
        avatar: {
            type: String,
            default: ''
        }
    },
    components: { SvgIcon, UserAvatar },
    data: function() {
        return {
            filename: "",
            filePreview: "",
            fileList: {}
        };
    },

    computed: {
        hasAvatar: function() {
            if (this.$user("id")) {
                return this.$user("has_avatar") === 1;
            } else {
                return true;
            }
        },
        preview: function() {
            return this.$user("name") ? this.$user("name") : "Preview";
        },
        showAvatar: function() {
            if (this.$route.path === "/settings") {
                return this.$user("has_avatar") === 1;
            } else {
                return true;
            }
        }
    },

    mounted() {
        this.filePreview = this.$user("id") && this.$user("has_avatar") === 1 ? this.$user("avatar") : "";
        this.filePreview =   this.filePreview || this.avatar     
    },

    methods: {
        addFile: function(e) {
            this.fileList = e.target.files[0];

            const reader = new FileReader();
            reader.readAsDataURL(this.fileList);

            reader.onload = () => {
                this.$emit("addAvatar", reader.result);
                if (this.$user("id")) {
                    this.$setState("userUpdate", { has_avatar: 1 });
                }
            };

            this.filename = this.fileList.name;
            this.filePreview = URL.createObjectURL(this.fileList);
        }
    }
};
</script>
